import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Portal from "@/pages/Portal";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/portal" element={<Portal />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
